import { render, staticRenderFns } from "./ClaimsbyProvider.vue?vue&type=template&id=31d0fc95&scoped=true&"
import script from "./ClaimsbyProvider.vue?vue&type=script&lang=js&"
export * from "./ClaimsbyProvider.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsbyProvider.vue?vue&type=style&index=0&id=31d0fc95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d0fc95",
  null
  
)

export default component.exports